var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    fill: "#0B45DB",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    stroke: "#0B45DB",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 17.1657C21.8333 20.499 19.5 22.1657 16.7267 23.1323C16.5814 23.1815 16.4237 23.1792 16.28 23.1257C13.5 22.1657 11.1667 20.499 11.1667 17.1657V12.499C11.1667 12.3222 11.2369 12.1526 11.3619 12.0276C11.487 11.9026 11.6565 11.8323 11.8333 11.8323C13.1667 11.8323 14.8333 11.0323 15.9933 10.019C16.1346 9.89833 16.3142 9.83203 16.5 9.83203C16.6858 9.83203 16.8654 9.89833 17.0067 10.019C18.1733 11.039 19.8333 11.8323 21.1667 11.8323C21.3435 11.8323 21.513 11.9026 21.6381 12.0276C21.7631 12.1526 21.8333 12.3222 21.8333 12.499V17.1657Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.5013L15.8333 17.8346L18.5 15.168",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithReport);
export default __webpack_public_path__ + "static/media/with-report.f9a8a079d6422e1bff3c715b1cfbc54f.svg";
export { ForwardRef as ReactComponent };